import 'core-js/stable';
import fetch from 'isomorphic-fetch';

const getParams = (method = 'GET') => ({ method });

const checkStatus = (response: Response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    (error as any).response = response;
    throw error;
  }
};

const doRequest = (method: string, url: string, data?: FormData) =>
  new Promise((resolve, reject) => {
    let params: Record<string, any> = getParams(method);

    // Use the FormData object cuz this won't work => JSON.stringify(data)
    if (data) params.body = data;

    fetch(url, params)
      .then(checkStatus)
      .then(resp =>
        resp.json().then(
          (json: unknown) => json,
          (error: unknown) => null
        )
      )
      .then(d => resolve(d))
      .catch(ex => {
        console.warn('API error (FROM api.js)');
        console.trace();
        reject(ex);
      });
  });

const doGet = (url: string) => doRequest('GET', url, undefined);
const doPost = (url: string, data?: FormData) => doRequest('POST', url, data);
const doPatch = (url: string, data?: FormData) => doRequest('PATCH', url, data);
const doPut = (url: string, data?: FormData) => doRequest('PUT', url, data);
const doDelete = (url: string, data?: FormData) => doRequest('DELETE', url, data);

let host = 'orbitalsites.com';
let protocol = 'https';

const API = {
  setHostAndProtocol: (incoming_host: string, incoming_protocol: string) => {
    host = incoming_host;
    protocol = incoming_protocol;
  },
  getPodcast: (protocol: string, host: string, uuid: string) =>
    doGet(`${protocol}://api.${host}/podcast/${uuid}.json`),
  getForm: (id: number | string) => doGet(`${protocol}://api.${host}/form/${id}.json`),
  submitForm: (id: number | string, data: FormData) =>
    doPost(`${protocol}://api.${host}/form/${id}`, data),
  getAnnouncements: (protocol: string, host: string, site: string) =>
    doGet(`${protocol}://api.${host}/announcements/${site}.json`),
  sendAnnouncementEvent: (protocol: string, host: string, announcement: string, name: string) =>
    doGet(`${protocol}://api.${host}/announcement/${announcement}/e/${name}`),
  getPcoData: (protocol: string, host: string, siteUniqueName: string, sectionType: string, params: Record<string, string> = {}) =>
    doGet(`${protocol}://api.${host}/pco/${siteUniqueName}/${sectionType}?${new URLSearchParams(params)}`),
  getPcoDetail: (protocol: string, host: string, siteUniqueName: string, itemType: string, itemId: string) =>
    doGet(`${protocol}://api.${host}/pco/${siteUniqueName}/detail/${itemType}/${itemId}`),
};

export default API;
